export interface PhoneCountryConfig {
  iso2: string;
  name: string;
  dialCode: string;
  /** Máximo de dígitos permitidos en el input. */
  nationalNumberLength: number;
  /** Si se define, la longitud válida es min..max inclusive. */
  nationalNumberLengthRange?: [number, number];
}

// LATAM + USA + CN + Europa (D, E, F). nationalNumberLength usado para validación client-side.
// Solo un país con +1 (NANP) para evitar ambigüedad al parsear.
const PHONE_COUNTRIES: PhoneCountryConfig[] = [
  { iso2: 'AR', name: 'Argentina', dialCode: '+54', nationalNumberLength: 10 },
  { iso2: 'BO', name: 'Bolivia', dialCode: '+591', nationalNumberLength: 8 },
  { iso2: 'BR', name: 'Brasil', dialCode: '+55', nationalNumberLength: 11 },
  { iso2: 'CL', name: 'Chile', dialCode: '+56', nationalNumberLength: 9 },
  { iso2: 'CN', name: 'China', dialCode: '+86', nationalNumberLength: 11 },
  { iso2: 'CO', name: 'Colombia', dialCode: '+57', nationalNumberLength: 10 },
  { iso2: 'CR', name: 'Costa Rica', dialCode: '+506', nationalNumberLength: 8 },
  { iso2: 'CU', name: 'Cuba', dialCode: '+53', nationalNumberLength: 8 },
  { iso2: 'EC', name: 'Ecuador', dialCode: '+593', nationalNumberLength: 9 },
  { iso2: 'SV', name: 'El Salvador', dialCode: '+503', nationalNumberLength: 8 },
  {
    iso2: 'US',
    name: 'Estados Unidos (USA)',
    dialCode: '+1',
    nationalNumberLength: 10,
  },
  { iso2: 'GT', name: 'Guatemala', dialCode: '+502', nationalNumberLength: 8 },
  { iso2: 'HN', name: 'Honduras', dialCode: '+504', nationalNumberLength: 8 },
  { iso2: 'MX', name: 'México', dialCode: '+52', nationalNumberLength: 10 },
  { iso2: 'NI', name: 'Nicaragua', dialCode: '+505', nationalNumberLength: 8 },
  { iso2: 'PA', name: 'Panamá', dialCode: '+507', nationalNumberLength: 8 },
  { iso2: 'PY', name: 'Paraguay', dialCode: '+595', nationalNumberLength: 9 },
  { iso2: 'PE', name: 'Perú', dialCode: '+51', nationalNumberLength: 9 },
  { iso2: 'UY', name: 'Uruguay', dialCode: '+598', nationalNumberLength: 8 },
  { iso2: 'VE', name: 'Venezuela', dialCode: '+58', nationalNumberLength: 10 },
  // Europa — Grupo D
  {
    iso2: 'DE',
    name: 'Alemania',
    dialCode: '+49',
    nationalNumberLength: 11,
    nationalNumberLengthRange: [10, 11],
  },
  {
    iso2: 'AT',
    name: 'Austria',
    dialCode: '+43',
    nationalNumberLength: 11,
    nationalNumberLengthRange: [10, 11],
  },
  { iso2: 'BE', name: 'Bélgica', dialCode: '+32', nationalNumberLength: 9 },
  { iso2: 'DK', name: 'Dinamarca', dialCode: '+45', nationalNumberLength: 8 },
  { iso2: 'ES', name: 'España', dialCode: '+34', nationalNumberLength: 9 },
  { iso2: 'FR', name: 'Francia', dialCode: '+33', nationalNumberLength: 9 },
  { iso2: 'GR', name: 'Grecia', dialCode: '+30', nationalNumberLength: 10 },
  { iso2: 'IE', name: 'Irlanda', dialCode: '+353', nationalNumberLength: 9 },
  {
    iso2: 'IT',
    name: 'Italia',
    dialCode: '+39',
    nationalNumberLength: 10,
    nationalNumberLengthRange: [9, 10],
  },
  { iso2: 'NL', name: 'Países Bajos', dialCode: '+31', nationalNumberLength: 9 },
  { iso2: 'PL', name: 'Polonia', dialCode: '+48', nationalNumberLength: 9 },
  { iso2: 'PT', name: 'Portugal', dialCode: '+351', nationalNumberLength: 9 },
  { iso2: 'GB', name: 'Reino Unido', dialCode: '+44', nationalNumberLength: 10 },
  { iso2: 'RO', name: 'Rumania', dialCode: '+40', nationalNumberLength: 9 },
  { iso2: 'RU', name: 'Rusia', dialCode: '+7', nationalNumberLength: 10 },
  { iso2: 'SE', name: 'Suecia', dialCode: '+46', nationalNumberLength: 9 },
  { iso2: 'CH', name: 'Suiza', dialCode: '+41', nationalNumberLength: 9 },
  { iso2: 'NO', name: 'Noruega', dialCode: '+47', nationalNumberLength: 8 },
];

export const PHONE_COUNTRIES_LATAM: readonly PhoneCountryConfig[] = [...PHONE_COUNTRIES].sort(
  (a, b) => a.name.localeCompare(b.name, 'es'),
);

export const DEFAULT_PHONE_COUNTRY_ISO = 'BO';
